import styled from 'styled-components';
import { BasketSelectSectionStyled } from '../BasketFinancePaymentSelectionStyled';
import { rem } from 'polished';

export const BasketFinancePaymentSelectionOV = styled(BasketSelectSectionStyled)`
    .section {
        &:hover,
        &:focus-visible {
            background: ${({ theme }) => theme.colors.pureWhite};
            border: 1px solid ${({ theme }) => theme.colors.primaryHover};

            .inner {
                border: 1px solid ${({ theme }) => theme.colors.primaryHover};
            }
        }

        &.selected {
            border-color: ${({ theme }) => theme.colors.primaryHover};
            background: ${({ theme }) => theme.colors.grey10};

            .inner {
                border-color: ${({ theme }) => theme.colors.primaryHover};
            }
        }

        .title {
            font-size: ${({ theme }) => theme.fontSizes.textMedium};

            .icon {
                &.selected {
                    background: ${({ theme }) => theme.colors.primary};
                    border-color: ${({ theme }) => theme.colors.primary};

                    .selected {
                        background: ${({ theme }) => theme.colors.primaryHover};
                    }
                }
            }
        }

        .summary {
            .totalPrice {
                font-size: ${rem(20)};
                color: ${({ theme }) => theme.colors.black2};
            }
            .otherPrices {
                font-size: ${({ theme }) => theme.fontSizes.textMedium};
                color: ${({ theme }) => theme.colors.black2};
            }

            .infoIcon {
                svg {
                    width: ${rem(20)};
                    height: ${rem(20)};
                    margin-top: ${rem(-2)};

                    path {
                        stroke: transparent;
                        fill: ${({ theme }) => theme.colors.black};
                    }
                }
            }
        }
        .description {
            font-size: ${({ theme }) => theme.fontSizes.textSubMedium};
            color: ${({ theme }) => theme.colors.grey28};
        }
    }
`;
